// Generated by https://quicktype.io

export class DatacapBatchRecord {
	businessDate: string;
	number: number;
	transactionCount: number;
	amount: number;
	transactions: Transaction[];
	startTime: string;
	endTime: string;

	public constructor(init?: Partial<DatacapBatchRecord>) {
		Object.assign(this, init);
	}
}

export interface DatacapReportingSummary {
	ProcessingTime: string;
	BusinessName: string;
	CurrentPageNumber: number;
	CurrentPageSize: number;
	MaxPageSize: number;
	TotalPageCount: number;
	Transactions: Transaction[];
}

export interface Transaction {
	Summary: Summary;
	Details?: Details;
}

export interface Details {
	Request?: string;
	Response?: string;
	RequestJson?: ParsedRequestFields;
	ResponseJson?: ParsedResponseFields;
}

export interface ParsedRequestFields {
	TStream: TStream;
}

export interface TStream {
	Transaction: TStreamTransaction;
}

export interface TStreamTransaction {
	AccountSource: string;
	Bridge: string;
	CardholderName: string;
	ClientID: string;
	CustomerCode: string;
	EMVAppID: string;
	EMVData: string;
	EMVEntrySource: string;
	EMVPANSeqNo: string;
	EMVTSCounter: string;
	EMVTerminalType: string;
	EncryptedBlock: string;
	EncryptedFormat: string;
	EncryptedKey: string;
	Frequency: string;
	InvoiceNo: string;
	MerchantID: string;
	OperatorID: string;
	PartialAuth: string;
	PinCapable: string;
	PinPadKernelVer: string;
	PinPadMfgSerialNo: string;
	PinPadSerialNo: string;
	Purchase: string;
	RecordNo: string;
	RefNo: string;
	SecureDevice: string;
	SequenceNo: string;
	Tax: string;
	Track2: string;
	TranCode: string;
	TranType: string;
}

export interface ParsedResponseFields {
	RStream: RStream;
}

export interface RStream {
	CmdResponse: CmdResponse;
	TranResponse: TranResponse;
	PayAPI_Id: string;
}

export interface CmdResponse {
	ResponseOrigin: ResponseOrigin;
	DSIXReturnCode: string;
	CmdStatus: Status;
	TextResponse: TextResponse;
	UserTraceData: string;
}

export enum Status {
	Approved = 'Approved',
}

export enum ResponseOrigin {
	Processor = 'Processor',
}

export enum TextResponse {
	Approval = 'APPROVAL',
}

export interface TranResponse {
	MerchantID: string;
	AcctNo: string;
	ExpDate: string;
	CardType: Card;
	TranCode: string;
	AuthCode: string;
	CaptureStatus: string;
	RefNo: string;
	InvoiceNo: string;
	EMVResult?: string;
	OperatorID: string;
	Amount: Amount;
	AcqRefData: string;
	RecordNo: string;
	BatchNo: string;
	CVVResult?: string;
}

export interface Amount {
	Purchase: string;
	Authorize: string;
	Gratuity: string;
}

export enum Card {
	Amex = 'AMEX',
	Dcvr = 'DCVR',
	MC = 'M/C',
	Visa = 'VISA',
}

export enum TranResponseTranCode {
	EMVSale = 'EMVSale',
}

export interface Summary {
	businessDate: string;
	TimeStamp: string;
	TranType: TranType;
	TranCode: TranCode;
	Status: Status;
	CardBrand: Card;
	LastFour: string;
	Invoice: string;
	Amount: number;
	Captured: boolean;
	Batch: number;
}

export enum TranCode {
	Adjust = 'Adjust',
	Return = 'Return',
	Sale = 'Sale',
	VoidReturn = 'VoidReturn',
	VoidSale = 'VoidSale',
	EMVSale = 'EMVSale',
}

export enum TranType {
	Credit = 'Credit',
}
